<template>
  <div style="margin-top: 30px;">
    <h1 style="text-align: center;">Upload PDF Component Editor</h1>
    <div>
      <div ref="cntTitle">
      <h2>Title</h2>
      <div><input type="text" v-model="title" style="width: 100%"></div>
    </div>
    <hr>
      <div ref="cntThumb">
        <h2>Thumbnail</h2>
        <div><img :src="thumbnail.data" height="200px" width="100%" style="object-fit: contain;"></div>
        <div><input type="file" ref="thumbsel" v-on:change="changeThumb()" accept="image/jpeg,image/jpg,image/png,image/tif" style="width: 100%; background: white;"></div>
      </div>
      <hr>
      <div ref="cntPDF">
        <div style="color:black">PDF Document : <span>{{ pdf.publicUrl }}</span></div>
        <div><input type="file" ref="pdfsel" accept="application/pdf" style="width: 100%; background: white;" @change="pdf.file = $event.target.files[0]"></div>
      </div>
    <div>
      <button @click="submit()" class="submit-btn">Submit</button>
    </div>
    </div>
  </div>
  
</template>

<script>
import {Functions} from './functions.js';
export default {
  name: "Pdf",
  props: ["ID"],
  data: () => ({
    isLoading: true,
    title: "",
    data: [],
    children: [],
    contentLength: 1,
    thumbnail: {
      file: undefined,
      data: "",
      publicUrl: "",
      uploadUrl: ""
    },
    pdf: {
      file: undefined,
      publicUrl: "",
      uploadUrl: ""
    },
    functions: undefined
  }),
  mounted: function() {
    
    this.functions = new Functions();
   if(this.ID)
   {
     //editing
    console.log("editing");
     this.functions.getComponent(this.ID, (data) => {
       let contentType;
       switch (data.rdsDat[0].Thumbnail)
       {
         case data.rdsDat[0].Thumbnail.indexOf('jpeg') >-1 : 
           contentType =  "image/jpeg"
           break;
         case data.rdsDat[0].Thumbnail.indexOf('jpg') > -1 :
            contentType = "image/jpg"
           break;
         case data.rdsDat[0].Thumbnail.indexOf('png') > -1 :
           contentType = "image/png"
           break;
         case data.rdsDat[0].Thumbnail.indexOf('tif') > -1 :
           contentType = "image/tif"
           break;
         default: 
           contentType = "image/jpeg";
       }
           this.functions.getSignedUrl("ttedu-static", data.rdsDat[0].Thumbnail, contentType, "getObject", (thumbBuff) => {
           this.thumbnail.data = (thumbBuff.signedUrl);
           //console.log("data -" +  this.thumbnail.data);
           this.functions.getSignedUrl("ttedu-static", data.rdsDat[0].Thumbnail, contentType, "putObject", (thumbBuff1) => {
             this.thumbnail.uploadUrl = thumbBuff1.signedUrl;
             
             this.functions.getSignedUrl("ttedu-static", data.rdsDat[0].Location, "application/pdf", "putObject", (pdfdat) => {
               this.pdf.publicUrl = data.rdsDat[0].Location;
               this.pdf.uploadUrl = pdfdat.signedUrl;
               this.title = data.title;
               this.thumbnail.publicUrl = data.rdsDat[0].Thumbnail;
               this.init();
             });
           });
         });
     });
   }
   else
   {
     //new 
     this.functions.getThumbURL((dat) => {
       this.thumbnail.publicUrl = dat.key;
       this.thumbnail.uploadUrl = dat.signedUrl;
       let uuid = this.functions.generateuuid(32);
       this.functions.getSignedUrl("ttedu-static", "book/" + uuid + ".pdf", "application/pdf", "putObject", (pdfdat) => {
         this.pdf.publicUrl = "book/" + uuid + ".pdf";
         this.pdf.uploadUrl = pdfdat.signedUrl;
         this.init();
       });
     });
   }
    },
  methods: {
    changeThumb: function(){
      var reader = new FileReader();
      reader.onload = (e) => {
        this.thumbnail.data = e.target.result;
      }
      reader.readAsDataURL(this.$refs.thumbsel.files[0]);
      this.thumbnail.file = this.$refs.thumbsel.files[0];
    },
    init: function(){
      if(this.ID){
        //do nothing
      }else{
        this.addChild();
        this.addChild();
        this.addBlank();
        this.addBlank();
      }
      this.functions.getAllComponents((dat) => {
        this.availableComponents = [];
        dat.forEach(d => {
          if((d.ParentContent == null || d.ParentContent == this.ID) && d.Component != null)
            this.availableComponents.push({
              type: d.Component,
              title: d.Title,
              id: d.ID
            });
        });
        // console.log(JSON.stringify(this.availableComponents));
        // this.allComponentTypes = [...new Set(this.availableComponents.map(x => x.type))]
        this.isLoading = false;
      });
    },
    addChild: function(){
      this.children.push({
        id: "",
        location: ""
      });
    },
    addBlank: function(){
      this.data.push({
        page: 1,
        index: 1,
        text: ""
      });
    },
    submit: function(){
      this.isLoading = true;
      let hasError = false;
      if(this.title.trim() == "") {this.$refs.cntTitle.classList.add("has-error"); hasError = true;}
      else this.$refs.cntTitle.classList.remove("has-error")
      if(this.thumbnail.file == undefined && this.ID == undefined) {this.$refs.cntThumb.classList.add("has-error"); hasError = true;}
      else this.$refs.cntThumb.classList.remove("has-error")
      if(this.pdf.file == undefined && this.ID == undefined) {this.$refs.cntPDF.classList.add("has-error"); hasError = true;}
      else this.$refs.cntPDF.classList.remove("has-error")

      let componentData = this.compileData();
      if(this.ID){
        //update
      if(this.thumbnail.file == undefined){
        // No thumbnail to update
        if(this.pdf.file == undefined){
          //----- No PDF to upload
          this.functions.updateBook(this.ID, componentData, (dat) => {
            //console.log(dat);
            this.$router.push("/editors/component/pdf");
          });
        }else{
          this.functions.uploadPDF(this.pdf.uploadUrl, this.pdf.file, (dat) => {
            this.functions.updateBook(this.ID, componentData, (dat) => {
              //console.log(dat);
              this.$router.push("/editors/component/pdf");
            });
          });
        }
      }else{
        this.functions.upload(this.thumbnail.uploadUrl, this.thumbnail.file, (dat) => {
          if(this.pdf.file == undefined){
            //----- No PDF to upload
            this.functions.updateBook(this.ID, componentData, (dat) => {
              //console.log(dat);
              this.$router.push("/editors/component/pdf");
            });
          }else{
            this.functions.uploadPDF(this.pdf.uploadUrl, this.pdf.file, (dat) => {
              this.functions.updateBook(this.ID, componentData, (dat) => {
                //console.log(dat);
                this.$router.push("/editors/component/pdf");
              });
            });
          }
        });
      }
      }
      else{
        //add new
         //this.isLoading = false;
         //console.log(componentData);return null;
        this.functions.upload(this.thumbnail.uploadUrl, this.thumbnail.file, (dat) => {
          this.functions.uploadPDF(this.pdf.uploadUrl, this.pdf.file, (dat) => {
            this.functions.addBook(componentData, (dat) => {
              //console.log(dat);
              this.$router.push("/editors/component/pdf");
            });
          });
        });
      }
    },
    compileData: function(){
      let componentData = {
        //ContentType is set to interactive for a pdf due to that is what is expected (user request)
        ContentType: "INTERACTIVE",
        Title: this.title,
        Thumbnail: this.thumbnail.publicUrl,
        Component: "pdf",
        Data: [],
        ContentLength: this.contentLength,
        Location: this.pdf.publicUrl,
        Children: JSON.stringify(this.children)
      };
      let buff = [];
      buff = new Blob([this.pdf.publicUrl]);
      componentData.Data = JSON.parse(JSON.stringify(buff));
      componentData.Component = "pdf";
      return componentData;
    }
  }
}
</script>

<style scoped>
hr {
  border: solid 2px white;
}
.quill-editor{
  background: white;
  color: black;
}
.ql-container.ql-snow{
  background: white !important;
}
div{
  color:black;
}
.submit-btn{
  width: 100%;
  height: 2em;
  font-size: 1.5em;
  font-weight: 800;
  margin-top: 0.5em;
}
.has-error{
  border: red 5px solid !important;
  box-sizing: border-box;
}
.has-error::after{
  content: "Missing content/invalid content.";
  color: red;
  background: white;
  font-weight: 800;
}
h2{
  color:black;
}
.loading{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  vertical-align: middle;
  justify-content: center;
  text-align: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  font-size: 4em;
  font-weight: 900;
}
</style>